import { Checkbox } from '@mantine/core'
import CheckboxClasses from './styles.module.css'

export default Checkbox.extend({
    defaultProps: {},
    classNames: CheckboxClasses,
})
